// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"3413fe01","115":"a4f10391","285":"2f62a426","336":"44f9dc4c","477":"853fe0c3","992":"1015577e"}[chunkId] + ".chunk.css";
};